var map = {
	"./IMG_2836.png": 1494,
	"./IMG_2836@2x.png": 1021,
	"./add_image.png": 1495,
	"./add_image@2x.png": 1022,
	"./app_download_banner_logo.png": 1496,
	"./arrow_left.png": 1497,
	"./button_arrowdown.png": 1498,
	"./button_arrowdown@2x.png": 1023,
	"./china.png": 1499,
	"./clearbutton.png": 1500,
	"./clearbutton@2x.png": 1024,
	"./dialog_order_finished_en.png": 1501,
	"./dl_andriod_blue.png": 1502,
	"./dl_andriod_blue@2x.png": 1025,
	"./dl_android_outline.png": 1503,
	"./dl_android_outline@2x.png": 1026,
	"./dl_apple_blue.png": 1504,
	"./dl_apple_blue@2x.png": 1027,
	"./dl_appstore.png": 1505,
	"./dl_appstore@2x.png": 1028,
	"./dl_appstore_hover_yl.png": 1506,
	"./dl_appstore_hover_yl@2x.png": 1029,
	"./dl_appstore_outline.png": 1507,
	"./dl_appstore_outline@2x.png": 1030,
	"./dl_appstore_white.png": 1508,
	"./dl_appstore_white@2x.png": 1031,
	"./dl_playstore.png": 1509,
	"./dl_playstore@2x.png": 1032,
	"./dl_playstore_hover_yl.png": 1510,
	"./dl_playstore_hover_yl@2x.png": 1033,
	"./dl_playstore_white.png": 1511,
	"./dl_playstore_white@2x.png": 1034,
	"./favicon-114x114.png": 1512,
	"./favicon-195x195.png": 1513,
	"./favicon-228x228.png": 1514,
	"./favicon-32x32.png": 1515,
	"./favicon-64x64.png": 1516,
	"./favicon-72x72.png": 1517,
	"./favicon-96x96.png": 1518,
	"./feature_lightbox1_en.png": 1519,
	"./feature_lightbox1_en@2x.png": 1035,
	"./feature_lightbox2.png": 1520,
	"./feature_lightbox2@2x.png": 1036,
	"./feature_lightbox3.png": 1521,
	"./feature_lightbox3@2x.png": 1037,
	"./feature_lightbox4_en.png": 1522,
	"./feature_lightbox4_en@2x.png": 1038,
	"./feature_lightbox5_en.png": 1523,
	"./feature_lightbox5_en@2x.png": 1039,
	"./feature_lightbox6_en.png": 1524,
	"./feature_lightbox6_en@2x.png": 1040,
	"./hero_iphone_en.png": 1525,
	"./hero_iphone_en@2x.png": 1041,
	"./hero_nexus_en.png": 1526,
	"./hero_nexus_en@2x.png": 1042,
	"./hero_video.png": 1527,
	"./hero_video@2x.png": 1043,
	"./hero_video_hover.png": 1528,
	"./hero_video_hover@2x.png": 1044,
	"./hongkong.png": 1529,
	"./icon-building-materials-transport.png": 1530,
	"./icon-building-materials-transport@2x.png": 1045,
	"./icon-courier.png": 1531,
	"./icon-courier@2x.png": 1046,
	"./icon-delivery.png": 1532,
	"./icon-delivery@2x.png": 1047,
	"./icon-how-it-work-step1_en.png": 1533,
	"./icon-how-it-work-step1_en@2x.png": 1048,
	"./icon-how-it-work-step2.png": 1534,
	"./icon-how-it-work-step2@2x.png": 1049,
	"./icon-how-it-work-step3.png": 1535,
	"./icon-how-it-work-step3@2x.png": 1050,
	"./icon-pet-shuttle-service.png": 1536,
	"./icon-pet-shuttle-service@2x.png": 1051,
	"./icon-right.png": 1537,
	"./icon-right@2x.png": 1052,
	"./icon-send-document.png": 1538,
	"./icon-send-document@2x.png": 1053,
	"./icon-supplies-moving.png": 1539,
	"./icon-supplies-moving@2x.png": 1054,
	"./icon-warehouse-transport.png": 1540,
	"./icon-warehouse-transport@2x.png": 1055,
	"./icon_5ton_blue.png": 1541,
	"./icon_5ton_blue@2x.png": 1056,
	"./icon_5ton_white.png": 1542,
	"./icon_5ton_white@2x.png": 1057,
	"./icon_9ton_blue.png": 1543,
	"./icon_9ton_blue@2x.png": 1058,
	"./icon_9ton_white.png": 1544,
	"./icon_9ton_white@2x.png": 1059,
	"./icon_add.png": 1545,
	"./icon_add@2x.png": 1060,
	"./icon_add_disabled.png": 1546,
	"./icon_add_disabled@2x.png": 1061,
	"./icon_add_hover.png": 1547,
	"./icon_add_hover@2x.png": 1062,
	"./icon_avatar.png": 1548,
	"./icon_avatar@2x.png": 1063,
	"./icon_avator40x40.png": 1549,
	"./icon_avator40x40@2x.png": 1064,
	"./icon_avator70x70.png": 1550,
	"./icon_avator70x70@2x.png": 1065,
	"./icon_birthday.png": 1551,
	"./icon_birthday@2x.png": 1066,
	"./icon_borrowcart_inactive.png": 1552,
	"./icon_borrowcart_inactive@2x.png": 1067,
	"./icon_calendar.png": 1553,
	"./icon_calendar@2x.png": 1068,
	"./icon_calendar_solidblue.png": 1554,
	"./icon_calendar_solidblue@2x.png": 1069,
	"./icon_camera.png": 1555,
	"./icon_camera@2x.png": 1070,
	"./icon_camera_disabled.png": 1556,
	"./icon_camera_disabled@2x.png": 1071,
	"./icon_camera_hover.png": 1557,
	"./icon_camera_hover@2x.png": 1072,
	"./icon_clear_2.png": 1558,
	"./icon_clear_2@2x.png": 1073,
	"./icon_clear_b.png": 1559,
	"./icon_clear_b@2x.png": 1074,
	"./icon_clock.png": 1560,
	"./icon_clock@2x.png": 1075,
	"./icon_clock_small.png": 1561,
	"./icon_clock_small@2x.png": 1076,
	"./icon_constructionwaste_inactive.png": 1562,
	"./icon_constructionwaste_inactive@2x.png": 1077,
	"./icon_courier.png": 1563,
	"./icon_courier@2x.png": 1078,
	"./icon_courier_blue.png": 1564,
	"./icon_courier_blue@2x.png": 1079,
	"./icon_courier_white.png": 1565,
	"./icon_courier_white@2x.png": 1080,
	"./icon_cross_r.png": 1566,
	"./icon_cross_r@2x.png": 1081,
	"./icon_deliveryservice.png": 1567,
	"./icon_deliveryservice@2x.png": 1082,
	"./icon_deliveryservice_blue.png": 1568,
	"./icon_deliveryservice_blue@2x.png": 1083,
	"./icon_deliveryservice_white.png": 1569,
	"./icon_deliveryservice_white@2x.png": 1084,
	"./icon_destination_pin_1.png": 1570,
	"./icon_destination_pin_2.png": 1571,
	"./icon_destination_pin_3.png": 1572,
	"./icon_destination_pin_4.png": 1573,
	"./icon_destination_pin_5.png": 1574,
	"./icon_destination_pin_6.png": 1575,
	"./icon_destination_pin_7.png": 1576,
	"./icon_destination_pin_8.png": 1577,
	"./icon_destination_pin_9.png": 1578,
	"./icon_done.png": 1579,
	"./icon_done@2x.png": 1085,
	"./icon_dropdownarrow_grey.png": 1580,
	"./icon_email.png": 1581,
	"./icon_email@2x.png": 1086,
	"./icon_english_inactive.png": 1582,
	"./icon_english_inactive@2x.png": 1087,
	"./icon_facebook.png": 1583,
	"./icon_facebook@2x.png": 1088,
	"./icon_feature1.png": 1584,
	"./icon_feature1@2x.png": 1089,
	"./icon_feature2.png": 1585,
	"./icon_feature2@2x.png": 1090,
	"./icon_feature3.png": 1586,
	"./icon_feature3@2x.png": 1091,
	"./icon_feature4.png": 1587,
	"./icon_feature4@2x.png": 1092,
	"./icon_feature5.png": 1588,
	"./icon_feature5@2x.png": 1093,
	"./icon_feature6.png": 1589,
	"./icon_feature6@2x.png": 1094,
	"./icon_from.png": 1590,
	"./icon_from@2x.png": 1095,
	"./icon_gender.png": 1591,
	"./icon_gender@2x.png": 1096,
	"./icon_googleplus.png": 1592,
	"./icon_googleplus@2x.png": 1097,
	"./icon_home_address.png": 1593,
	"./icon_home_address@2x.png": 1098,
	"./icon_hourlyrental_inactive.png": 1594,
	"./icon_hourlyrental_inactive@2x.png": 1099,
	"./icon_industry.png": 1595,
	"./icon_industry@2x.png": 1100,
	"./icon_instagram.png": 1596,
	"./icon_instagram@2x.png": 1101,
	"./icon_linkedin.png": 1597,
	"./icon_linkedin@2x.png": 1102,
	"./icon_loading_complete.png": 1598,
	"./icon_loading_complete@2x.png": 1103,
	"./icon_loading_small.png": 1599,
	"./icon_loading_small@2x.png": 1104,
	"./icon_location_1.png": 1600,
	"./icon_location_1@2x.png": 1105,
	"./icon_location_2.png": 1601,
	"./icon_location_2@2x.png": 1106,
	"./icon_locations_full.png": 1602,
	"./icon_locations_full@2x.png": 1107,
	"./icon_longergood_inactive.png": 1603,
	"./icon_longergood_inactive@2x.png": 1108,
	"./icon_mail.png": 1604,
	"./icon_mail@2x.png": 1109,
	"./icon_mid.png": 1605,
	"./icon_mid@2x.png": 1110,
	"./icon_motorcycle_blue.png": 1606,
	"./icon_motorcycle_blue@2x.png": 1111,
	"./icon_motorcycle_white.png": 1607,
	"./icon_motorcycle_white@2x.png": 1112,
	"./icon_moving.png": 1608,
	"./icon_moving@2x.png": 1113,
	"./icon_moving_w.png": 1609,
	"./icon_moving_w@2x.png": 1114,
	"./icon_movingservice.png": 1610,
	"./icon_movingservice@2x.png": 1115,
	"./icon_movingservice_blue.png": 1611,
	"./icon_movingservice_blue@2x.png": 1116,
	"./icon_movingservice_white.png": 1612,
	"./icon_movingservice_white@2x.png": 1117,
	"./icon_naver.png": 1613,
	"./icon_naver@2x.png": 1118,
	"./icon_newcar_inactive.png": 1614,
	"./icon_newcar_inactive@2x.png": 1119,
	"./icon_notification.png": 1615,
	"./icon_notification@2x.png": 1120,
	"./icon_ordering_hourly_clock.png": 1616,
	"./icon_ordering_hourly_clock@2x.png": 1121,
	"./icon_passengerservice.png": 1617,
	"./icon_passengerservice@2x.png": 1122,
	"./icon_passengervan.png": 1618,
	"./icon_passengervan@2x.png": 1123,
	"./icon_passengervan_w.png": 1619,
	"./icon_passengervan_w@2x.png": 1124,
	"./icon_password.png": 1620,
	"./icon_password@2x.png": 1125,
	"./icon_pets_inactive.png": 1621,
	"./icon_pets_inactive@2x.png": 1126,
	"./icon_phone.png": 1622,
	"./icon_phone@2x.png": 1127,
	"./icon_phone_white.png": 1623,
	"./icon_phone_white@2x.png": 1128,
	"./icon_phone_white_big.png": 1624,
	"./icon_phone_white_big@2x.png": 1129,
	"./icon_porterage_inactive.png": 1625,
	"./icon_porterage_inactive@2x.png": 1130,
	"./icon_question.png": 1626,
	"./icon_question@2x.png": 1131,
	"./icon_question_hover.png": 1627,
	"./icon_question_hover@2x.png": 1132,
	"./icon_rate.png": 1628,
	"./icon_rate@2x.png": 1133,
	"./icon_rate_y.png": 1629,
	"./icon_rate_y@2x.png": 1134,
	"./icon_ridewithgood_blue.png": 1630,
	"./icon_ridewithgood_blue@2x.png": 1135,
	"./icon_ridewithgood_white.png": 1631,
	"./icon_ridewithgood_white@2x.png": 1136,
	"./icon_ridewithgoodsicon.png": 1632,
	"./icon_ridewithgoodsicon@2x.png": 1137,
	"./icon_ridewithgoodsicon_blue.png": 1633,
	"./icon_ridewithgoodsicon_blue@2x.png": 1138,
	"./icon_ridewithgoodsicon_w.png": 1634,
	"./icon_ridewithgoodsicon_white.png": 1635,
	"./icon_ridewithgoodsicon_white@2x.png": 1139,
	"./icon_selected.png": 1636,
	"./icon_selected@2x.png": 1140,
	"./icon_send_to.png": 1637,
	"./icon_send_to@2x.png": 1141,
	"./icon_ser_10ftlorry.png": 1638,
	"./icon_ser_10ftlorry@2x.png": 1142,
	"./icon_ser_14ftlorry.png": 1639,
	"./icon_ser_14ftlorry@2x.png": 1143,
	"./icon_ser_24ftlorry.png": 1640,
	"./icon_ser_24ftlorry@2x.png": 1144,
	"./icon_ser_bike.png": 1641,
	"./icon_ser_bike@2x.png": 1145,
	"./icon_ser_courier.png": 1642,
	"./icon_ser_courier@2x.png": 1146,
	"./icon_ser_delivery.png": 1643,
	"./icon_ser_delivery@2x.png": 1147,
	"./icon_ser_everythingelse.png": 1644,
	"./icon_ser_everythingelse@2x.png": 1148,
	"./icon_ser_moving.png": 1645,
	"./icon_ser_moving@2x.png": 1149,
	"./icon_ser_passenger.png": 1646,
	"./icon_ser_passenger@2x.png": 1150,
	"./icon_ser_smallfreight.png": 1647,
	"./icon_ser_smallfreight@2x.png": 1151,
	"./icon_ser_van.png": 1648,
	"./icon_ser_van@2x.png": 1152,
	"./icon_smallfreight.png": 1649,
	"./icon_smallfreight@2x.png": 1153,
	"./icon_smallfreight_blue.png": 1650,
	"./icon_smallfreight_blue@2x.png": 1154,
	"./icon_smallfreight_white.png": 1651,
	"./icon_smallfreight_white@2x.png": 1155,
	"./icon_steps1.png": 1652,
	"./icon_steps1@2x.png": 1156,
	"./icon_steps1_activated.png": 1653,
	"./icon_steps1_activated@2x.png": 1157,
	"./icon_steps2.png": 1654,
	"./icon_steps2@2x.png": 1158,
	"./icon_steps2_activated.png": 1655,
	"./icon_steps2_activated@2x.png": 1159,
	"./icon_steps3.png": 1656,
	"./icon_steps3@2x.png": 1160,
	"./icon_steps3_activated.png": 1657,
	"./icon_steps3_activated@2x.png": 1161,
	"./icon_to.png": 1658,
	"./icon_to@2x.png": 1162,
	"./icon_twitter.png": 1659,
	"./icon_twitter@2x.png": 1163,
	"./icon_van.png": 1660,
	"./icon_van@2x.png": 1164,
	"./icon_van_blue.png": 1661,
	"./icon_van_blue@2x.png": 1165,
	"./icon_van_white.png": 1662,
	"./icon_van_white@2x.png": 1166,
	"./icon_work_address.png": 1663,
	"./icon_work_address@2x.png": 1167,
	"./icon_youtube.png": 1664,
	"./icon_youtube@2x.png": 1168,
	"./img_404.png": 1665,
	"./img_404@2x.png": 1169,
	"./img_driverprofile_fallback.png": 1666,
	"./img_driverprofile_fallback@2x.png": 1170,
	"./img_step1.png": 1667,
	"./img_step1@2x.png": 1171,
	"./index_hero/gogobusiness/gogovan_logo.png": 1668,
	"./index_hero/gogobusiness/gogovan_logo@2x.png": 1172,
	"./index_hero/gogobusiness/imac.png": 1669,
	"./index_hero/gogobusiness/imac@2x.png": 1173,
	"./india.png": 1670,
	"./india@2x.png": 1174,
	"./map_marker_1.png": 1671,
	"./map_marker_1@2x.png": 1175,
	"./map_marker_2.png": 1672,
	"./map_marker_2@2x.png": 1176,
	"./map_marker_3.png": 1673,
	"./map_marker_3@2x.png": 1177,
	"./map_marker_4.png": 1674,
	"./map_marker_4@2x.png": 1178,
	"./map_marker_5.png": 1675,
	"./map_marker_5@2x.png": 1179,
	"./map_marker_6.png": 1676,
	"./map_marker_6@2x.png": 1180,
	"./map_marker_7.png": 1677,
	"./map_marker_7@2x.png": 1181,
	"./map_marker_8.png": 1678,
	"./map_marker_8@2x.png": 1182,
	"./map_marker_9.png": 1679,
	"./map_marker_9@2x.png": 1183,
	"./map_marker_van.png": 1680,
	"./media_36kr.png": 1681,
	"./media_36kr@2x.png": 1184,
	"./media_appledaily.png": 1682,
	"./media_appledaily@2x.png": 1185,
	"./media_channelnewsasia.png": 1683,
	"./media_channelnewsasia@2x.png": 1186,
	"./media_d100.png": 1684,
	"./media_d100@2x.png": 1187,
	"./media_e27.png": 1685,
	"./media_e27@2x.png": 1188,
	"./media_econtimes.png": 1686,
	"./media_econtimes@2x.png": 1189,
	"./media_ezone.png": 1687,
	"./media_ezone@2x.png": 1190,
	"./media_ibt.png": 1688,
	"./media_ibt@2x.png": 1191,
	"./media_metro_broadcast.png": 1689,
	"./media_metro_broadcast@2x.png": 1192,
	"./media_pcm.png": 1690,
	"./media_pcm@2x.png": 1193,
	"./media_rthk.png": 1691,
	"./media_rthk@2x.png": 1194,
	"./media_singtao.png": 1692,
	"./media_singtao@2x.png": 1195,
	"./media_techcrunch.png": 1693,
	"./media_techcrunch@2x.png": 1196,
	"./media_techinasia.png": 1694,
	"./media_techinasia@2x.png": 1197,
	"./media_thestraitstimes.png": 1695,
	"./media_thestraitstimes@2x.png": 1198,
	"./media_unwire.png": 1696,
	"./media_unwire@2x.png": 1199,
	"./media_weekender.png": 1697,
	"./media_weekender@2x.png": 1200,
	"./media_wsj.png": 1698,
	"./media_wsj@2x.png": 1201,
	"./nav_logo.png": 1699,
	"./nav_logo@2x.png": 1202,
	"./partnerships_ikea.png": 1700,
	"./partnerships_ikea@2x.png": 1203,
	"./partnerships_kfc.png": 1701,
	"./partnerships_kfc@2x.png": 1204,
	"./partnerships_logos_eprint.png": 1702,
	"./partnerships_logos_eprint@2x.png": 1205,
	"./partnerships_logos_spacious.png": 1703,
	"./partnerships_logos_spacious@2x.png": 1206,
	"./partnerships_nike.png": 1704,
	"./partnerships_nike@2x.png": 1207,
	"./partnerships_pizzahut.png": 1705,
	"./partnerships_pizzahut@2x.png": 1208,
	"./partnerships_pricerite.png": 1706,
	"./partnerships_pricerite@2x.png": 1209,
	"./pricing_icon.png": 1707,
	"./pricing_icon@2x.png": 1210,
	"./singapore.png": 1708,
	"./south_korea.png": 1709,
	"./steps_video.png": 1710,
	"./steps_video@2x.png": 1211,
	"./steps_video_hover.png": 1711,
	"./steps_video_hover@2x.png": 1212,
	"./swire.png": 1712,
	"./swire@2x.png": 1213,
	"./taiwan.png": 1713,
	"./verify_sender_phone.png": 1714,
	"./verify_sender_phone@2x.png": 1214,
	"./world_map_dots.png": 1715,
	"./world_map_dots@2x.png": 1215,
	"./yellowtip.png": 1716,
	"./yellowtip@2x.png": 1216
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 970;


//////////////////
// WEBPACK FOOTER
// ./src/assets/src/src_img ^\.\/.*\.png$
// module id = 970
// module chunks = 0